export default __webpack_public_path__ + "static/media/arrow.31c6d6a2.svg";